import React from 'react';
import Button from 'react-bootstrap/Button';
import BuyModal from './BuyModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCartPlus } from '@fortawesome/free-solid-svg-icons'
import { showModal } from '../../redux/ui/actions'
import { connect } from 'react-redux'
import { getProductOfferings, getProduct } from '../../redux/state'

class BuyButton extends React.Component {

  constructor(props){
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  render() {

    const { hasOfferings, label, variant, id, mode, className, size, block } = this.props

    if(!hasOfferings){
      return null
    }

    const modal = <BuyModal
      id={id}
      resource="products"
      />

    if(mode === 'icon'){
      return (
        <React.Fragment>
          <button title={label} onClick={this.handleClick} className={className}>
            <FontAwesomeIcon icon={faCartPlus} />
          </button>
          {modal}
        </React.Fragment>
      )
    }

    return (
      <React.Fragment>
        <Button variant={variant || 'light'} title={label} onClick={this.handleClick} className={className} size={size} block={block}>
          <FontAwesomeIcon icon={faCartPlus} className="me-2" /><span className="text-nowrap">{label}</span>
        </Button>
        {modal}
      </React.Fragment>
    )
  }

  handleClick(e){
    e.stopPropagation()
    const { dispatch } = this.props
    dispatch(showModal('offerings-products',this.props.id, true))
    if(this.props.handleClick){
      this.props.handleClick(e)
    }
  }


}

const mapStateToProps = (state, ownProps) => {
  const { user } = state

  // Check for owner
  const authenticated = (user && user.id)

  const hasOfferings = Boolean(getProductOfferings(state, ownProps.id))

  const product = getProduct(state, ownProps.id)

  return {
    authenticated,
    hasOfferings,
    label : 'Buy now'
  }
}

export default connect(mapStateToProps)(BuyButton)